<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200  shadow-sm sm:rounded-lg">
            <p class="text-lg font-medium mb-4">Generates Certificates </p>
            <div class="grid gap-4 grid-cols-3">

                <div>

                    <FormMultiselect
                        required
                        @change="loadWorkshopCertificate"
                        label="Select Certificate Type"
                        :options="certificateOptions"
                        track-key="id"
                        label-key="title"
                        return-value="id"
                        v-model="form.certificate_type"
                        placeholder="Select "
                        :error="form.errors.certificate_type"
                    />

                </div>

                <div v-if="form.certificate_type == 'software_certificate'">
                    <FormMultiselect
                        label="Select software Type"
                        :options="software"
                        track-key="id"
                        label-key="title"
                        return-value="id"
                        v-model="form.software_type"
                        placeholder="Select"
                        required
                        :error="form.errors.software_type"
                    />

                </div>

                <div>

                    <FormMultiselect
                        required
                        v-if="toggleWorkshop"
                        label="Select Workshop"
                        :options="workshopOptions"
                        track-key="id"
                        label-key="title"
                        return-value="id"
                        v-model="form.course_id"
                        placeholder="Select "
                        :error="form.errors.course_id"
                    />
                    <FormMultiselect
                        v-else
                        required
                        @change="setCourseId"
                        label="Select Course"
                        :options="coursesOptions"
                        track-key="id"
                        label-key="title"
                        :object="true"
                        v-model="course_id"
                        placeholder="Select "
                        :error="form.errors.course_id"
                    />

                </div>


            </div>
            <div class="mt-4">
                <!--                :disabled="form.processing"-->
                <BreezeButton @click="submit">Fetch Student</BreezeButton>
            </div>


        </div>


        <div class="bg-white rounded-md p-6 mt-6">

            <div class="flex justify-end my-4">
                <!--                :disabled="form.processing"-->
                <BreezeButton v-if="hasRole('Create Certificate')" @click="generateCertificate">Generate Certificate
                </BreezeButton>
            </div>
            <breeze-input-error :message="form.errors?form.errors.selected_students:''"/>

            <breeze-table
                v-if="toggleWorkshop"
                :fields="[
                {'key': 'check', 'label': 'Sr.'},
                {'key': 'name', 'label': 'Name'},
                { 'key': 'mobile', 'label': 'Mobile' },
                {'key': 'course', 'label': 'Course Name'},
                {'key': 'action', 'label': 'Action'},
                ]"
                :items="worshopTable"
                :canView="hasRole('View Certificate')"
            >
                <template #action="data">
                    <a v-if="data.item.admission?.certificate?.pdf" :href="data.item.admission?.certificate?.pdf"
                       class="inline-flex items-center px-4 py-2  border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none
                         focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 bg-gray-800"
                       :download="`${data.item.admission.student.first_name}-${data.item.admission.student.last_name}-certificate.pdf`">Download</a>
                </template>
                <template #thcheck>
                    <input type="checkbox"
                           v-model="form.all" :value="true"
                           class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200
                                                    focus:ring-opacity-50 disabled:!bg-gray-200 disabled:cursor-not-allowed"/>
                </template>
                <template #check="data">
                    <input :checked="true" type="checkbox"
                           v-model="form.selected_students" :value="data.item.id"
                           class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200
                                focus:ring-opacity-50 disabled:!bg-gray-200 disabled:cursor-not-allowed"/>
                </template>
                <template #name="data">
                    {{ data.item.admission.student.first_name }}
                    {{ data.item.admission.student.middle_name }}
                    {{ data.item.admission.student.last_name }}
                </template>
                <template #course="data">
                    {{ data.item.admission.course.title }}
                    {{ data.item.admission.courseyear.title }}
                </template>
                <template #mobile="data">
                    {{ data.item.admission.student.mobile }}
                </template>
            </breeze-table>
            <breeze-table
                v-else
                :fields="[
                {'key': 'check', 'label': 'Sr.'},
                {'key': 'name', 'label': 'Name'},
                { 'key': 'mobile', 'label': 'Mobile' },
                {'key': 'course', 'label': 'Course Name'},
                {'key': 'action', 'label': 'Action'},
                ]"
                :items="students"
                :canView="true"
            >
                <template #action="data">
                    <a v-if="data.item?.certificate?.pdf"
                       :href="data.item?.certificate?.pdf"

                       class="inline-flex items-center px-4 py-2  border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none
     focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 bg-gray-800"
                       :download="`${data.item.student.first_name}-${data.item.student.last_name}-certificate.pdf`">Download</a>
                </template>
                <template #thcheck>
                    <input type="checkbox"
                           v-model="form.all" :value="true"
                           class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200
            focus:ring-opacity-50 disabled:!bg-gray-200 disabled:cursor-not-allowed"/>
                </template>
                <template #check="data">
                    <input :checked="true" type="checkbox"
                           v-model="form.selected_students" :value="data.item.id"
                           class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200
            focus:ring-opacity-50 disabled:!bg-gray-200 disabled:cursor-not-allowed"/>
                </template>
                <template #name="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.middle_name }}
                    {{ data.item.student.last_name }}
                </template>
                <template #course="data">
                    {{ data.item.course.title }}
                    {{ data.item.courseyear.title }}
                </template>
                <template #mobile="data">
                    {{ data.item.student.mobile }}
                </template>
            </breeze-table>
        </div>
    </internal>
</template>
<script setup>

import BreezeTable from "@/Components/NewTable";
import Internal from "@/Pages/Internal/Internal.vue";
import {computed, ref, watch} from "vue";
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import BreezeButton from "@/Components/Button";
import BreezeInputError from "@/Components/InputError";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import {hasRole} from "../../../../Utils/checkPermission";

const props = defineProps({
    courses: Object,
    software: Object,
    branch_id: String,
});
const form = useForm({
    course_id: '',
    certificate_type: '',
    software_type: '',
    selected_students: [],
    all: false
})
const students = ref([]);
const course_id = ref([]);
const workshopOptions = ref([]);
const worshopTable = ref([]);


const setCourseId = (item) => {
    form.course_id = item?.course_id;
}
const loadWorkshopCertificate = (value) => {
    if (value == 'workshop_certificate' || !(workshopOptions?.length)) {
        form.post(route('internal.generate-certificates.workshop', usePage().props.value.branch_id), {
            onSuccess: (resp) => {
                workshopOptions.value = resp.props.flash.data;
            }
        });
    }

}

const toggleWorkshop = computed(() => {
    return (form.certificate_type == 'workshop_certificate');
})
watch(() => form.all, (_new, _old) => {
    if (_new) {
        students.value.map((item) => {
            form.selected_students.push(item.id);
        });
    } else {
        form.selected_students = [];
    }
})

const coursesOptions = computed(() => {
    var data = [];
    props.courses.forEach(item => {
        data.push({id: item.id, course_id: item.course.id, title: item.course.title + " " + item.title});
    });
    return data;
});

const certificateOptions = [
    {id: 'private_certificate', title: "Private Certificate"},
    {id: 'software_certificate', title: "Software Certificate"},
    {id: 'workshop_certificate', title: "Workshop Certificate"},
];
const submit = () => {
    form.post(route('internal.generate-certificates.student', props.branch_id), {
        onSuccess: (resp) => {

            if (toggleWorkshop.value) {
                worshopTable.value = resp.props.flash.data;
            } else {
                students.value = resp.props.flash.data;
            }
        }
    });
}
const generateCertificate = () => {
    form.post(route('internal.generate-certificates.store', props.branch_id), {
        onSuccess: () => {
            alert('certificate successfully generated.');
            submit();
            form.selected_students = [];
        }
    });
}
</script>
